export default __webpack_public_path__ + "static/media/mail.866b4e75.svg";